import { isLanguageEqual } from './cookie';
import { getDictionaryText } from './getDictionaryText';
import { LANGUAGE_CODE, BAIDU_API_KEY, GOOGLE_API_KEY } from '../../constants';

export const getAPIKey = language => {
  const apiKeyText =
    isLanguageEqual(language, LANGUAGE_CODE.CHINESE)
      ? BAIDU_API_KEY
      : GOOGLE_API_KEY;
  return getDictionaryText(apiKeyText);
};
